import { createSelector } from 'reselect';
import sortedModules from './sortedModules';

export default (selector: () => number[]) =>
    createSelector(sortedModules, selector, (modules, list) =>
        modules.filter((item) => list.includes(item.id)),
    );
